import * as React from 'react';
import { useEffect } from 'react';

const VideoMedia = ({
  id,
  url,
  fadeDirection = 'right',
}: {
  id: string;
  url: string;
  fadeDirection?: 'none' | 'right' | 'left';
}) => {
  const videoNode = React.useRef<HTMLVideoElement>(document.createElement('HTMLVideoElement') as HTMLVideoElement);
  useEffect(() => {
    if (videoNode.current) {
      videoNode.current.load();
    }
  }, [url]);
  return (
    <div
      className="brand-fade overscroll-none"
      style={
        fadeDirection !== 'none'
          ? {
              mask: `linear-gradient(to ${fadeDirection}, transparent 0%, black 100%) ${
                fadeDirection === 'right' ? 'left' : 'right'
              }`,
              maskRepeat: 'no-repeat',
            }
          : {}
      }
    >
      <video
        ref={videoNode}
        playsInline
        autoPlay
        loop
        muted
        disablePictureInPicture
        id={id}
        style={{
          minWidth: '100%',
          minHeight: '100%',
          zIndex: 1,
          objectFit: 'cover',
          width: '100%',
          height: 'auto',
          top: '50%',
          transform: ' translateY(-50%)',
          position: 'absolute',
          overscrollBehavior: 'none',
        }}
      >
        <source src={url || ''} type="video/mp4" />
      </video>
      {/*
      <div
       className='bg-transparent brand-fade relative z-10 flex h-full min-w-[340px] max-w-[380px] flex-col items-start gap-sm self-stretch'
      />
      */}
    </div>
  );
};

export default VideoMedia;
